module.exports = __webpack_public_path__ + "img/249.e14d6fbb.jpg";